<template>
	<div>
		<topTab ref="topTab" :tab-data="tabData" @tab-change="changePages">
			<lcsj-filter :show-search="false" more-text="更多筛选" @search="inputChange()">
			<template #query>
				<el-button v-if="$checkBtnPermission('/inputStore/index', 'viewPage')" size="small" type="primary" class="el-icon-search" @click="inputChange()">搜索</el-button>
				<el-button v-if="$checkBtnPermission('/inputStore/index', 'reset')" size="small" icon="el-icon-refresh" @click="clearAll">重置</el-button>
			</template>
			<template #actions><el-button v-if="$checkBtnPermission('/inputStore/index', 'create')" size="small" type="primary" class="el-icon-plus" @click="handleEdit()">新增</el-button></template>
			<el-form-item label="供应商：">
					<el-select v-model="formInline.supplyKeyId" placeholder="请选择供应商" clearable size="small" @change="inputChange">
						<el-option v-for="item in supplyList" :key="item.keyId" :label="item.name" :value="item.keyId"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="入库单号：">
					<el-input clearable v-model="formInline.inputStoreNo" size="small" placeholder="请输入入库单号" @keyup.enter.native="inputChange"></el-input>
				</el-form-item>
				<el-form-item label="入库类型：">
					<el-select v-model.number="formInline.inputType" placeholder="请选择入库类型" size="small" @change="inputChange">
						<el-option v-for="item in inputTypeList" :key="item.code" :label="item.name" :value="item.code"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="入库时间：">
					<el-date-picker
						v-model="inputDateList"
						type="daterange"
						value-format="yyyy-MM-dd"
						range-separator="~"
						start-placeholder="开始日期"
						end-placeholder="结束日期"
						format="yyyy-MM-dd"
						clearable
						size="small"
						@change="changeDate"
					/>
				</el-form-item>
			</lcsj-filter>
			<STable :columns="columnsData" :data="listData" :loading="loading" border @get-data="getListData" @row-dblclick="handleRowClick">
				<template #inputStoreNo>
					<el-table-column align="center" label="入库单号" width="220">
						<template #default="scope">
							<el-link :underline="false" type="primary">
								{{ scope.row.inputStoreNo }}
							</el-link>
						</template>
					</el-table-column>
				</template>

				<template #operateColumn>
					<el-table-column align="center" label="操作" fixed="right" width="180">
						<template #default="scope">
							<el-button v-if="btnPermission.delete && !scope.row.inputUserKeyId" size="small" type="danger" class="el-icon-delete" @click="deleteInputStore(scope.row)">删除</el-button>
						</template>
					</el-table-column>
				</template>
			</STable>
			<!-- 分页组件 -->
			<Pagination v-if="pageShow" :child-msg="pageparm" @call-father="callFather"></Pagination>
		</topTab>
		<!-- 编辑 -->
		<edit ref="edit"></edit>
		<!-- 详情 -->
		<detail ref="detail"></detail>
		<!-- 类型2详情 -->
		<type2Detail ref="type2Detail"></type2Detail>
	</div>
</template>

<script>
import { getSupplyInfoList } from "@/api/baseDataApi.js";
import { GetInputStorePageList, DeleteInputStore } from "@/api/receiptApi.js";
import { GetEnumConfigListByCode } from "@/api/enumApi.js";
import edit from "./edit";
import detail from "./detail";
import type2Detail from "./type2Detail.vue";
export default {
	data() {
		return {
			activeTab: "1",
			tabData: [
				{
					key: "1",
					value: "入库单列表"
				}
			],
			pageShow: true,
			loading: false, // 显示加载
			listData: [],
			supplyList: [],
			selectionList: [],
			inputDateList: [],
			inputTypeList: [],
			// 分页参数
			pageparm: {
				pageIndex: 1,
				pageSize: 10,
				total: 0
			},
			formInline: {
				pageIndex: 1,
				pageSize: 10,
				supplyKeyId: "",
				inputStoreNo: "",
				startTime: null,
				endTime: null,
				inputType: 0
			},
			columnsData: [], //显示列
			listColumns: [
				{
					prop: "keyId",
					label: "全选",
					align: "center",
					width: "55",
					isKeep: true,
					selection: true
				},
				{
					prop: "rowNumber",
					label: "序号",
					align: "center",
					width: "80",
					isKeep: true
				},
				{
					prop: "inputStoreNo",
					label: "入库单编号",
					align: "center",
					isKeep: true,
					minWidth: "220",
				},
				{
					prop: "inputTypeStr",
					label: "入库类型",
					align: "center",
					isKeep: true,
					minWidth: "150",
				},
				{
					prop: "inputUserName",
					label: "入库人",
					align: "center",
					minWidth: "80"
				},
				{
					prop: "inputDate",
					label: "入库时间",
					align: "center",
					minWidth: "160"
				},
				{
					prop: "goodsType",
					label: "商品品牌",
					align: "center",
					minWidth: "120"
				},
				{
					prop: "goodsName",
					label: "商品名称",
					align: "center",
					minWidth: "160"
				},
				// {
				//   prop: "supply.name",
				//   label: "供应商",
				//   align: "center",
				//   minWidth: "120",
				// },
				// {
				//   prop: "supply.contactPhone",
				//   label: "供应商电话",
				//   align: "center",
				//   minWidth: "120",
				// },
				{
					prop: "remark",
					label: "备注",
					align: "center",
					minWidth: "150"
				},
				{
					prop: "creator",
					label: "创建人",
					align: "center",
					minWidth: "80"
				},
				{
					prop: "createTime",
					label: "创建时间",
					align: "center",
					minWidth: "150"
				},
				{
					prop: "editor",
					label: "维护人",
					align: "center",
					minWidth: "80"
				},
				{
					prop: "updateTime",
					label: "维护时间",
					align: "center",
					minWidth: "150"
				},
				{
					slot: "operateColumn",
					isKeep: true,
					label: "操作",
					fixed: "right",
					minwidth: "80"
				}
			],
			// 按钮权限
			btnPermission: {
				delete: false
			}
		};
	},
	// 注册组件
	components: {
		edit,
		detail,
		type2Detail
	},
	created() {
		// 初始列
		this.getCheckBox(this.listColumns.map((item) => item.label));
		this.getListData();
		this.getSupplyInfoList();
		// 按钮权限
		this.getBtnPermission();
		this.GetEnumConfigListByCode();
	},
	computed: {},
	methods: {
		// 获取筛选框
		getCheckBox(val) {
			let arr = this.listColumns.filter((v) => !val.includes(v.label));
			this.columnsData = this.listColumns.filter((i) => !arr.includes(i));
		},
		changePages() {},
		// 获取供应商
		getSupplyInfoList() {
			const paramer = {};
			getSupplyInfoList(paramer)
				.then((res) => {
					if (res.code == 1) {
						this.supplyList = res.data;
					} else {
						this.$message.error(res.msg);
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("获取供应商信息失败!");
				});
		},
		// 双击行数据
		handleRowClick(row) {
			if (row.inputType == 1) {
				this.$refs.detail.showDetailDialog(row.keyId);
			} else {
				this.$refs.type2Detail.showDetailDialog(row.keyId);
			}
		},
		//显示编辑界面
		handleEdit(row) {
			if (row == null || row == undefined) {
				this.$refs.edit.showCreateDialog("", false);
			} else {
				this.$refs.edit.showCreateDialog(row.keyId, true);
			}
		},
		// 删除
		deleteInputStore(row) {
			this.$confirm("确定要删除入库单【" + row.inputStoreNo + "】吗?", "信息", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			}).then(() => {
				let parmter = {
					keyId: row.keyId
				};
				DeleteInputStore(parmter)
					.then((res) => {
						if (res.code === 1) {
							this.$message({
								type: "success",
								message: "已删除!"
							});
							this.getListData();
						} else {
							this.$message({
								type: "info",
								message: res.msg
							});
						}
					})
					.catch((err) => {
						this.loading = false;
						this.$message.error("删除失败，请稍后再试！");
					});
			});
		},
		// 获取列表
		getListData() {
			this.loading = true;
			GetInputStorePageList(this.formInline)
				.then((res) => {
					if (res.code == 1) {
						this.loading = false;
						this.listData = res.data;
						this.pageparm.total = res.totalNumber;
					} else {
						this.$message({
							type: "info",
							message: res.msg
						});
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("数据加载失败，请稍后再试！");
				});
		},
		// 重置
		clearAll() {
			this.$data.formInline = this.$options.data.call(this).formInline;
			this.search();
		},
		inputChange(val) {
			this.search();
		},
		// 分页插件事件
		callFather(parm) {
			if (parm.currentPage == undefined) {
				this.formInline.pageIndex = 1;
			} else {
				this.formInline.pageIndex = parm.currentPage;
			}
			this.formInline.pageSize = parm.pageSize;
			this.getListData();
		},
		// 搜索事件
		search() {
			this.formInline.pageIndex = 1;
			this.pageShow = false;
			this.$nextTick(() => {
				this.pageShow = true;
			});
			this.getListData();
		},
		// 时间选择
		changeDate(val) {
			if (val) {
				this.formInline.startTime = val[0];
				this.formInline.endTime = val[1];
			} else {
				this.formInline.startTime = null;
				this.formInline.endTime = null;
			}
		},
		// 按钮权限
		getBtnPermission() {
			this.btnPermission.delete = this.$checkBtnPermission("/inputStore/index", "delete");
		},
		//获取状态信息
		GetEnumConfigListByCode() {
			const paramer = {
				code: "InputType"
			};
			GetEnumConfigListByCode(paramer)
				.then((res) => {
					if (res.code == 1) {
						this.inputTypeList = [];
						res.data.forEach((item) => {
							this.inputTypeList.push({
								code: parseInt(item.code),
								name: item.name
							});
						});
						this.inputTypeList.unshift({
							code: 0,
							name: "全部"
						});
					} else {
						this.$message.error(res.msg);
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("获取状态信息失败!");
				});
		}
	}
};
</script>

<style scoped>

</style>
